var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.productIsLoaded)?_c('div',{staticClass:"flex items-center py-3"},[_c('div',{staticClass:"flex-grow py-2 px-4 xs:hidden"},[_c('h3',[_vm._v(_vm._s(_vm.productTitle))]),_c('div',{staticClass:"mt-1"},[_vm._v(_vm._s(_vm.currentColor))])]),(_vm.currentRoute !== 'basket')?_c('div',{class:_vm.$style['slot']},[_vm._t("default")],2):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }